var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalena({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5857_48345)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5857_48345",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.894531H0V23.4828H24V0.894531Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5857_48345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 14.247V19.9529C13.009 19.9115 13.2582 19.8305 13.4859 19.7037L18.519 16.9892C18.8805 16.7934 19.1799 16.5106 19.3869 16.1698C19.5937 15.829 19.7004 15.4426 19.6962 15.0502V9.64864C19.7027 9.43104 19.6626 9.21445 19.5785 9.01172L14.1337 11.9758C12.9859 12.7236 12.75 13.4162 12.75 14.247Z",
    fill: "#455079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7031 7.10547L20.3969 8.35029C20.4774 8.58802 20.5232 8.83502 20.5326 9.08441V15.3421C20.5304 15.7931 20.4042 16.2358 20.1666 16.6275C19.9289 17.019 19.5875 17.3461 19.1759 17.5769L13.3746 20.7061C13.1057 20.8348 12.8208 20.9314 12.5264 20.9934V23.4837C12.9325 23.4237 13.3236 23.2942 13.6799 23.1008L21.2106 19.042C21.7274 18.7597 22.1562 18.3545 22.454 17.8669C22.7516 17.3794 22.9079 16.8267 22.9067 16.2644V8.159C22.9052 7.799 22.8362 7.44253 22.7031 7.10547Z",
    fill: "#455079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0845 12.3619C12.4437 11.8414 12.9321 11.4104 13.5072 11.1079L19.1705 8.03027C18.9863 7.80403 18.7607 7.61121 18.5009 7.46313L13.3264 4.66654C12.9513 4.47022 12.5291 4.36719 12.0999 4.36719C11.6706 4.36719 11.2484 4.47022 10.8733 4.66654L5.72561 7.45935C5.45977 7.6094 5.22406 7.80234 5.0293 8.02932L10.6617 11.1076C11.2308 11.419 11.7168 11.848 12.0845 12.3619Z",
    fill: "#455079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86027 6.88065L10.627 3.75183C11.0473 3.5319 11.5202 3.41649 12.001 3.41649C12.4819 3.41649 12.9548 3.5319 13.375 3.75183L19.1756 6.88065C19.4697 7.04097 19.7243 7.25866 19.9218 7.51912L22.2281 6.27394C21.9657 5.9234 21.6165 5.63845 21.2106 5.44383L13.6795 1.32536C13.1645 1.04319 12.5793 0.894533 11.9834 0.894531C11.3875 0.894533 10.8022 1.04319 10.2873 1.32536L2.82402 5.41242C2.42455 5.62954 2.07796 5.92316 1.80664 6.2743L4.11289 7.51947C4.3018 7.2519 4.55931 7.03219 4.86027 6.88065Z",
    fill: "#455079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6266 20.7044L4.86022 17.5757C4.44367 17.3499 4.09844 17.0241 3.86 16.6313C3.62158 16.2386 3.49852 15.7932 3.50347 15.3408V9.08317C3.50183 8.84456 3.53593 8.60694 3.60472 8.37728L1.29847 7.13281C1.1657 7.45907 1.09672 7.80522 1.09484 8.15458V16.2962C1.08472 17.4345 1.73497 18.487 2.79097 19.0421L10.291 23.1009C10.6472 23.2943 11.038 23.4242 11.4445 23.4839V20.9938C11.1542 20.9553 10.8764 20.8572 10.6307 20.7065L10.6266 20.7044Z",
    fill: "#455079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83829 11.7443L4.24605 8.71484C4.18561 8.91961 4.1554 9.13133 4.1554 9.34683V14.9495C4.15099 15.3545 4.26123 15.7534 4.47477 16.1049C4.68831 16.4566 4.99746 16.7484 5.37048 16.9504L10.5336 19.7518C10.7744 19.867 11.0295 19.9534 11.2931 20.009V14.1143C11.2595 13.257 11.0194 12.5419 9.83526 11.7418L9.83829 11.7443Z",
    fill: "#455079"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5857_48345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalena);
export default __webpack_public_path__ + "static/media/balena.5781f303a148ae967fee538be2250505.svg";
export { ForwardRef as ReactComponent };